var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtnBottom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  x: 36,
  y: 36,
  fill: "#F3F3F3",
  fillOpacity: 0.8,
  rx: 18,
  transform: "rotate(-180 36 36)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 35.037,
  height: 35.037,
  x: 35.519,
  y: 35.519,
  stroke: "#fff",
  strokeWidth: 0.963,
  rx: 17.519,
  transform: "rotate(-180 35.519 35.519)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#777",
  fillRule: "evenodd",
  d: "M17.219 25.105V9.947h1.894v15.158z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#777",
  fillRule: "evenodd",
  d: "m18.061 26.053-6.998-6.98 1.206-1.103 5.792 5.863 6.003-5.56 1.207 1.103z",
  clipRule: "evenodd"
})));
export default SvgBtnBottom;